import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { FC, SyntheticEvent } from 'react';
import {useLocale} from "./useLocale.ts";
import {t} from "@lingui/core/macro";

export type LocalSelectMap = {[localeKey: string]: string};

type LocaleProps = {
  locales: LocalSelectMap;
}

const Locale: FC<LocaleProps> = ({locales}) => {

  const { localeKey, selectLocaleKey } = useLocale();
  const keys = Object.keys(locales);

  return (
    <Autocomplete
      options={keys}
      getOptionLabel={(key) => key ? locales[key] : '' }
      getOptionKey={(option) => keys[option]}
      value={localeKey}
      disableClearable
      onChange={(_: SyntheticEvent, newValue: string) => {
          selectLocaleKey(newValue)
      }}
      renderInput={(params) => (
        <TextField {...params} label={t`Language`} fullWidth />
      )}
    />
  );
}

export default Locale;
